// Validador único de `next` (N1, decisión del Founder 2026-10-07, ver
// F:\Temp\diseno_beauty_H1_H2_v4.md §10.3 / I20).
//
// Hasta esta entrega, NADA en el frontend validaba ni usaba un query param
// `next` -- LoginPage.js siempre mandaba a postLoginPath(), App.js
// (PublicRoute) siempre mandaba por rol, y lib/api.js siempre mandaba a
// "/login" a secas al fallar el refresh de sesión. Esto rompía un caso
// real: un cliente que está a mitad del wizard de onboarding
// (/onboarding/:token) y cuya sesión vence (o nunca se creó) termina en
// /login sin ninguna forma de volver automáticamente a su enlace.
//
// Esta función es el ÚNICO lugar que decide si un valor de `next` es
// seguro para navegar. lib/api.js, LoginPage.js y App.js (PublicRoute)
// DEBEN importarla -- ninguno de los tres vuelve a implementar su propio
// criterio, para que nunca existan dos validadores que puedan divergir
// (el riesgo exacto que describe la v4, I20).
//
// Alcance deliberadamente angosto, por instrucción explícita del Founder
// ("solo rutas internas permitidas: /onboarding/<token> y las que la v4
// liste"): hoy la ÚNICA ruta interna que produce o necesita consumir
// `next` es la reanudación del wizard de onboarding Beauty
// (/onboarding/:token, ver App.js). No se "adivina" ninguna otra ruta
// interna (ni /dashboard, ni /portal/:id, ni /start) -- ampliar esta
// lista es una decisión de producto explícita, no un detalle de
// implementación, y debe hacerse aquí y en ningún otro lugar.
//
// Reglas de seguridad (rechazar URLs externas/maliciosas, CLAUDE.md §5):
//   - debe ser un string;
//   - debe empezar con exactamente UNA barra ("/"), nunca "//" (protocol-
//     relative: un navegador interpreta "//evil.com" como un host externo)
//     ni "\" (algunos navegadores normalizan "\" a "/" y permiten el mismo
//     ataque);
//   - nunca un esquema (http:, https:, javascript:, data:, etc.) -- la
//     regex exige que el primer carácter después de "/onboarding/" sea
//     parte del token, no "/" ni ":";
//   - sin query string, fragmento, espacios ni saltos de línea incrustados;
//   - el token solo acepta el alfabeto típico de un identificador opaco de
//     Mongo/URL-safe (letras, números, "-", "_"), largo acotado -- rechaza
//     "..", espacios, codificaciones percent-encoded sin decodificar y
//     cualquier intento de path traversal.
const ONBOARDING_TOKEN_RE = /^[A-Za-z0-9_-]{6,200}$/;

export function safeOnboardingNext(next) {
  if (typeof next !== "string") return null;
  if (next.length === 0 || next.length > 220) return null;
  if (!next.startsWith("/") || next.startsWith("//") || next.startsWith("\\")) return null;
  const parts = next.split("/");
  // ["", "onboarding", "<token>"] -- exactamente 3 segmentos, el del medio
  // literal "onboarding", el último validado por ONBOARDING_TOKEN_RE.
  if (parts.length !== 3) return null;
  if (parts[0] !== "" || parts[1] !== "onboarding") return null;
  const token = parts[2];
  if (!ONBOARDING_TOKEN_RE.test(token)) return null;
  return `/onboarding/${token}`;
}

// Construye el `next` canónico para un token de onboarding dado -- usado
// por lib/api.js (refresh de sesión fallido) para no duplicar el formato
// "/onboarding/<token>" en dos archivos distintos.
export function onboardingNextFor(token) {
  if (typeof token !== "string" || !token) return null;
  return safeOnboardingNext(`/onboarding/${token}`);
}
